<template>
  <!-- 文章详情和资讯详情公用组件 -->
	<div class="article-detail-wrap" v-if="data">
    <div class="main" v-if="isNews">
      <section class="yf-thumb">当前位置：<nuxt-link to="/article">文章</nuxt-link> &gt; <nuxt-link :to="`/article/list?irSid=${data.irCatalog}`">{{ newsType(data.irCatalog) }}</nuxt-link> &gt; 详情</section>
    </div>
		<!--文章详情-->
		<div class="detail cjg main">
			<!--文章-->
			<div class="detail_text_wrap left">
				<p  class="title"><span v-show="data.type === 1" class="cjgflag">CJG</span>{{ data.title || data.irUrltitle }}</p>
				<div class="name_wrap">
					<div class="img_wrap left" v-if="!isNews"><img :src="data.userAvatar" :alt="data.userName" /></div>
          <p v-if="isNews">
            <span class="name">{{ data.irLasttime | time }}</span>
            <span class="time">来源：{{ data.irGroupname }}</span>
            <span class="number right">阅读<i> {{ data.irBbsnum }}</i></span>
          </p>
					<p v-else>
            <span class="name">{{ data.userName }}</span>
            <span class="time">发表时间：{{ data.createAt }}</span>
						<!-- cjg显示服务时间 -->
            <span v-if="data.type === 1" class="number cjgnum right">服务时间：{{ data.createAt }}至{{ data.endTime }}</span>
						<!-- 除了购买页面其他都显示阅读量 -->
            <span v-else-if="view !== 'buy'" class="number right">阅读<i> {{ data.viewCount }}</i></span>
          </p>
				</div>
        <!-- 内容 -->
        <y-buy v-if="view === 'buy'" :data="data" :promotion="promotion"></y-buy>
        <y-cjg-detail v-else-if="view === 'cjg'" :data="data"></y-cjg-detail>
        <y-detail v-else :data="data"></y-detail>
        <!-- 内容 over -->
			</div>
			<!-- 右邊 -->
			<div class="detail_right right">
				<div class="auther_wrap" v-if="teacher && !isNews">
					<div class="auther">
						<img :src="teacher.avatar" :alt="teacher.userName">
					</div>
					<p class="name">
            <i>{{ teacher.userName }}</i>
            <span class="btn-ask" v-if="!isTeacher" :class="!isLike ? 'guanzhu' : 'yiguanzhu'" @click="handleLike">{{ !isLike ? '关注' :'已关注' }}</span>
            <nuxt-link class="btn-ask" v-if="teacher.roomId" :to="`/room/${teacher.roomId}`">{{ isTeacher ? "直播室" : '看直播' }}</nuxt-link>
          </p>
					<p class="text">{{ teacher.sign }}</p>
				</div>
				<div class="detail_list">
					<p class="title">{{ isNews ? `最新${newsType(data.irCatalog)}资讯` : 'TA的其他文章' }}<nuxt-link target="_blank" rel="noopener" class="right" :to="`/article/list${isNews ? '?irSid=' + data.irCatalog : '/' + teacher.id}`" >查看更多...</nuxt-link></p>
					<div class="detail_text" v-for="item of otherArticle" :key="item.id || item.irSid">
						<nuxt-link target="_blank" rel="noopener" class="text" :to="{ params : { id: item.id || item.irSid }, query: { irSid: item.irSid } }" ><span></span>{{ item.title || item.irUrltitle }}</nuxt-link>
						<p class="time">{{ item.createAt || item.irLasttime }}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Dialog from '@/utils/Dialog'
import YBuy from '@/components/articles/Buy'
import YDetail from '@/components/articles/Detail'
import YCjgDetail from '@/components/articles/CjgDetail'

export default {
  name: 'article-detail',
  scrollToTop: true,
  validate ({ params }) {
    return params.id > 0
  },
  async asyncData ({ params, query, store, error, $axios }) {
    let isNews = query.irSid !== undefined
    let apiUrl = isNews ? '/Information/Detail' : '/Article/Detail'
    let apiParams = {}
    apiParams[`${isNews ? 'irsId' : 'id'}`] = params.id

    let data = await $axios._get(apiUrl, apiParams)
		if (!data) {
			error({ statusCode: 500, message: '数据加载错误，请重试' })
      return
    }
    // console.log(data)
    // 获取老师信息
    if (!isNews) {
      await store.dispatch('teacher/getInfo', data.userId)
    }
    
    return {
      data,
      view: (data.gcoins > 0 && data.isBuy === 0) ? 'buy' : (data.type === 1 ? 'cjg' : 'noraml'),
      promotion: data.promotion || null,
      isLike: store.getters['user/likeTeacherIds'].indexOf(data.userId) !== -1
    }
  },
  head () {
    if (this.data) {
      return {
        title: this.isNews ? this.data.irUrltitle : this.data.title + '-' + this.data.userName + '-一富财经—打造中国最靠谱的的投资者教育平台,股市直播,股票交流'
      }
    }
  },
	data () {
		return {
			otherArticle: []
		}
	},
	mounted () {
    // 异步加载老师的其他文章
    let api, params = {}
    if (this.isNews) {
      // api = '/Information/OtherList'
      // params = {
      //   type: this.data.irCatalog,
      //   num: 5,
      //   page: 1
      // }
    } else {
      api = '/Article/List'
      params = {
        page: 1,
        num: 5,
        teacher: this.data.userId,
        order: 'teacher'
      }
    }

    this.$axios._get(api, params).then(res => {
      this.otherArticle = res.list ? res.list : res
    })
	},
	methods:{
		handleLike () {
			if (!this.$isLogin()) {
				Dialog.login()
				return
			}
      this.$store.dispatch('user/like', { teacher: this.teacher, isLike: this.isLike }).then(resp => {
        this.$notify({
          title: '成功',
          message: this.isLike ? '已取消关注':'关注成功',
          type: 'success'
  	  	})
        this.isLike = !this.isLike
      })
		},
    newsType (v) {
      let name = ''
      switch (Number(v)) {
        case 1:
          name = '证券'
          break
        case 2:
          name = '国内财经'
          break
        case 3:
          name = '新股动态'
          break
        case 4:
          name = '港股'
          break
        case 5:
          name = '公司要闻'
          break
      }
      return name
    }
	},
	computed: {
    isNews () {
      return this.$route.query.irSid !== undefined
    },
    isTeacher () {
      return this.$store.getters['user/isTeacher']
    },
    teacher () {
      return this.$store.state.teacher.data
    }
  },
  filters: {
    time (v) {
      let data = v.split(' ')
      let a = data[0].replace(/-/g, '/')
      return a + ' ' + data[1].slice(0, 5)
    }
  },
  components: {
    YBuy,
    YDetail,
    YCjgDetail
  }
}
</script>
